import { useMcpTool } from 'webmcp-react'
import { uiStore } from 'shared/store/uiStore'
import { InboxesApi } from 'entities/Inbox'
import { ConversationsApi } from 'entities/Conversation'
import { MessagesApi } from 'entities/Message'
import { ConversationRoutes } from 'entities/ExportRouters'
import { listInboxesSchema, sendMessageSchema } from 'entities/WebMcp/model/schemas'
import { serializeInbox } from 'entities/WebMcp/lib/serializers'
import { okResult, errorResult } from 'entities/WebMcp/lib/toolResult'

/**
 * Registers the WebMCP messaging tools. Renders nothing.
 *
 * send_message is a write — it has NO readOnlyHint, so the agent gates it
 * behind the approve/deny card. Sending is a two-step server flow done
 * client-side: get-or-create the conversation for (contact, inbox), then
 * create the message.
 */
export const MessagingTools = () => {
  useMcpTool({
    name: 'list_inboxes',
    description:
      'List the sending inboxes/teams. Use an inbox id as team_id when sending. eligible=false inboxes cannot send.',
    input: listInboxesSchema,
    annotations: { readOnlyHint: true },
    handler: async () => {
      try {
        const { data } = await InboxesApi.getTeamsAll()
        return okResult(data.map(serializeInbox))
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  useMcpTool({
    name: 'send_message',
    description:
      'Send an SMS to a contact from a sending inbox. Requires contact_id, message, and team_id (an inbox id from list_inboxes).',
    input: sendMessageSchema,
    handler: async ({ contact_id, message, team_id }) => {
      try {
        const { data: conversation } = await ConversationsApi.create({ contact_id, team_id })
        await MessagesApi.createMessage(conversation.id, { message, media_url: [] })
        uiStore.changeRouteViaVue({ path: `/${ConversationRoutes.root}/${conversation.id}` })
        return okResult({ sent: true, conversation_id: conversation.id })
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  return null
}
